module.exports = __webpack_public_path__ + "img/ppr-calendar-filters-all.8883b8b9.svg";